import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

export const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.55);
`

export const Card = styled.div`
  width: 597px;
  min-height: 302px;
  padding-top: 75px;
  padding-bottom: 40px;
  max-height: 90vh;

  position: relative;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background: rgba(255, 255, 255, 0.2);
  border: 1.84534px solid rgba(188, 188, 188, 0.74);
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  border-radius: 33px;
  
  animation: 2s ease-in-out infinite;
  z-index: 9999;
  
  @media (max-width: ${customTheme.breakpoints[1]}) {
    max-width: 90%;
    max-height: 70vh;
    margin-top: 8vh;
  }
`

export const Content = styled.div`
  max-width: 500px;
  overflow: hidden;
  overflow-y: auto;

  & > div {
    color: #fff;

    & > div, p, h1, h2, strong, span {
      margin: 10px;
    }
  }
    
  & {
    scrollbar-width: thin;
    scrollbar-color: #fff rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 20px;
    border: 3px solid rgba(255,255,255, .19);
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    max-height: unset;
  }
`

export const H3 = styled.h3`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  color: #FFFFFF;
  cursor: default;
`

export const EllipseWrapper = styled.div`
  position: absolute;
  top: -68px;
`
